// The crew app's four tabs (TZ 8, STAGE_5 5.1): calls, shift, expense, history.

import { DOCTOR_HOME } from '@/app/navigation';

export const CREW_TABS = ['calls', 'shift', 'expense', 'history'] as const;
export type CrewTab = (typeof CREW_TABS)[number];

export const crewPath = (tab: CrewTab) => `${DOCTOR_HOME}/${tab}`;

/** The call card of a call, at a step (1-based) or at the first. */
export const reportPath = (callId: number, step?: number, fromHistory = false) => {
  const query = new URLSearchParams({
    ...(step ? { step: String(step) } : {}),
    ...(fromHistory ? { from: 'history' } : {}),
  }).toString();
  return `${DOCTOR_HOME}/calls/${String(callId)}/report${query ? `?${query}` : ''}`;
};

/** The payment screen of a call the crew has completed. */
export const paymentPath = (callId: number) => `${DOCTOR_HOME}/calls/${String(callId)}/payment`;

/** A call of "History", read-only, and its call card by steps, read-only. */
export const historyCallPath = (callId: number) => `${DOCTOR_HOME}/history/${String(callId)}`;
export const historyCardPath = (callId: number, step?: number) =>
  `${historyCallPath(callId)}/card${step ? `?step=${String(step)}` : ''}`;
